import { gql } from "@apollo/client";

export const CLIP_STORAGE_STATUS = gql`
  query MyClipStorage {
    me {
      clipStorageStatus {
        success
        savedCount
        limit
      }
    }
  }
`;
